
/* eslint-disable */
// THIS FILE WAS GENERATED
// ALL CHANGES WILL BE OVERWRITTEN

// ARCHITECTURE START
  type FetchResponse<T> = {
    json: T;
    status: number;
    args: any;
  };
  
  type Configuration = {
    jwtKey: string | undefined;
    onResponse?: (response: FetchResponse<any>) => void;
  };
  
  let CONFIG: Configuration = {
    jwtKey: undefined,
    onResponse: () => {},
  };
  
  export function configureApiCalls(configuration: Configuration) {
    CONFIG = { ...CONFIG, ...configuration };
  }
  
  async function fetchJson<T>(...args: any): Promise<FetchResponse<T>> {
    const errorResponse = (status: number, args: any) => {
      const errorResponse = { status: status, json: null as any, args };
      CONFIG.onResponse && CONFIG.onResponse(errorResponse);
      return errorResponse;
    }

    try {
      const res: Response = await (fetch as any)(...args);
      try {
        const json = await res.json();
        const response = { json: json, status: res.status, args };
        CONFIG.onResponse && CONFIG.onResponse(response);
        return response;
      }
      catch {
        return errorResponse(res.status, args)
      }
    } catch {
      return errorResponse(503, args);
    }
  }
  
  const updateHeaders = (headers: Headers) => {
    if (!headers.has("Content-Type")) {
      headers.append("Content-Type", "application/json");
    }
    const token = CONFIG.jwtKey
      ? localStorage.getItem(CONFIG.jwtKey as any)
      : undefined;
    if (!headers.has("Authorization") && token) {
      headers.append("Authorization", token);
    }
  };

function apiPost<TResponse, TRequest>(
  url: string,
  request: TRequest,
  headers: Headers
) {
  var raw = JSON.stringify(request);
  updateHeaders(headers);
  var requestOptions = {
    method: "POST",
    headers,
    body: raw,
    redirect: "follow",
  };

  return fetchJson<TResponse>(url, requestOptions as any);
}

type ParamsObject = {
  [key: string]: any;
};

function apiGet<TResponse>(
  url: string,
  headers: Headers,
  paramsObject: ParamsObject = {}
) {
  updateHeaders(headers);
  const queryString = Object.entries(paramsObject)
    .filter(([_, val]) => val !== undefined && val !== null)
    .map(([key, val]) => `${key}=${val}`)
    .join("&");
  const maybeQueryString = queryString.length > 0 ? `?${queryString}` : "";
  const requestOptions = {
    method: "GET",
    headers,
    redirect: "follow",
  };
  return fetchJson<TResponse>(`${url}${maybeQueryString}`, requestOptions);
}

function apiPut<TResponse, TRequest>(
  url: string,
  request: TRequest,
  headers: Headers
) {
  updateHeaders(headers);

  var raw = JSON.stringify(request);

  var requestOptions = {
    method: "PUT",
    headers,
    body: raw,
    redirect: "follow",
  };

  return fetchJson<TResponse>(url, requestOptions as any);
}

function apiDelete<TResponse>(
  url: string,
  headers: Headers,
  paramsObject: ParamsObject = {}
) {
  updateHeaders(headers);
  const queryString = Object.entries(paramsObject)
    .filter(([_, val]) => val !== undefined && val !== null)
    .map(([key, val]) => `${key}=${val}`)
    .join("&");
  const maybeQueryString = queryString.length > 0 ? `?${queryString}` : "";

  var requestOptions = {
    method: "DELETE",
    headers,
    redirect: "follow",
  };
  return fetchJson<TResponse>(`${url}${maybeQueryString}`, requestOptions);
}

function apiPatch<TResponse, TRequest>(
  url: string,
  request: TRequest,
  headers: Headers
) {
  updateHeaders(headers);

  var raw = JSON.stringify(request);

  var requestOptions = {
    method: "PATCH",
    headers,
    body: raw,
    redirect: "follow",
  };

  return fetchJson<TResponse>(url, requestOptions as any);
}
// ARCHITECTURE END

export const API_ROUTES = { 
	postTicketGetList: "/api/Ticket/get-list",
	postTicketGetSubordinatesTickets: "/api/Ticket/get-subordinates-tickets",
	postTicketChangeStatus: "/api/Ticket/change-status",
	postAccessRolesGetList: "/api/AccessRoles/get-list",
	getAccessRolesGetDetail: "/api/AccessRoles/get-detail",
	putAccessRolesUpdateAccessRights: "/api/AccessRoles/update-access-rights",
	postInvoiceItemCategoriesGetList: "/api/InvoiceItemCategories/get-list",
	getInvoiceItemCategoriesGetDetail: "/api/InvoiceItemCategories/get-detail",
	postInvoiceItemCategoriesSave: "/api/InvoiceItemCategories/save",
	getInvoiceItemCategoriesGetDivisions: "/api/InvoiceItemCategories/get-divisions",
	postHumanResourceGetEmployeeList: "/api/HumanResource/get-employee-list",
	getHumanResourceGetEmployee: "/api/HumanResource/get-employee",
	postHumanResourceSaveEmployee: "/api/HumanResource/save-employee",
	deleteHumanResourceDeleteEmployee: "/api/HumanResource/delete-employee",
	getHumanResourceDepartmentsAutocomplete: "/api/HumanResource/departments-autocomplete",
	postHumanResourcePositionsAutocomplete: "/api/HumanResource/positions-autocomplete",
	postHumanResourceEmployeesAutocomplete: "/api/HumanResource/employees-autocomplete",
	getHumanResourceCompanyAutocomplete: "/api/HumanResource/company-autocomplete",
	getHumanResourceGetEmployeeTypeList: "/api/HumanResource/get-employee-type-list",
	postCompaniesGetList: "/api/Companies/get-list",
	getCompaniesGetCompany: "/api/Companies/get-company",
	postCompaniesSaveCompany: "/api/Companies/save-company",
	deleteCompaniesDeleteCompany: "/api/Companies/delete-company",
	getCompaniesGetAllIdentificationNumbers: "/api/Companies/get-all-identification-numbers",
	postCompaniesSaveCompanyContactPerson: "/api/Companies/save-company-contact-person",
	deleteCompaniesDeleteCompanyContactPerson: "/api/Companies/delete-company-contact-person",
	postUsersGetList: "/api/Users/get-list",
	getUsersGetUser: "/api/Users/get-user",
	getUsersGetLoggedUserInfo: "/api/Users/get-logged-user-info",
	deleteUsersDeleteUser: "/api/Users/delete-user",
	postUsersUpdate: "/api/Users/update",
	postAuthSignIn: "/api/Auth/sign-in",
	getAuthCurrentUserAccessRights: "/api/Auth/current-user-access-rights",
	postCacheClear: "/api/Cache/Clear",
	postLogError: "/api/Log/Error",
	postApplicationsGetGuidepost: "/api/Applications/get-guidepost",
	postApplicationsLogApplicationVisit: "/api/Applications/log-application-visit",
	getApplicationsGetCurrentDocs: "/api/Applications/get-current-docs",
	postApplicationsRunDailyJob: "/api/Applications/run-daily-job",
	getGuidepostPlugin: "/api/Guidepost/plugin"
}

export interface GetTicketsResponse {
	tickets: TicketListDto[];
	employeeID?: number | null;
}

export interface TicketListDto {
	ticketID: number;
	dueDate?: string | null;
	title: string;
	description: string;
	tooltip?: string | null;
	externalLinkUrl?: string | null;
	externalLinkText?: string | null;
	customSvgIcon?: string | null;
	groupCode?: string | null;
	ticketsInGroupCount: number;
	ticketsAfterDueDateCount: number;
	isCancelationDisabled: boolean;
	severity: TicketSeverity;
	status: TicketStatus;
	type: TicketType;
	isStatusChangePerformedByExternalSystem: boolean;
	additionalInfo?: string | null;
}

export enum TicketSeverity {
	Info = "Info",
	Warning = "Warning",
	Critical = "Critical"
}

export enum TicketStatus {
	Created = "Created",
	Resolved = "Resolved",
	InvalidResolve = "InvalidResolve",
	Canceled = "Canceled"
}

export enum TicketType {
	Warning = "Warning",
	Reminder = "Reminder",
	CustomActions = "CustomActions"
}

export interface GetTicketsRequest {
	employeeID?: number | null;
}

export interface SubordinatesTicketListDto {
	employeeID: number;
	firstName: string;
	lastName: string;
	imgUrl?: string | null;
	ticketsCount: number;
	ticketsAfterDueDateCount: number;
}

export interface ResultOfTicketChangeStatusResponse {
	data?: any | null;
	isValid: boolean;
	validationErrors?: ValidationMessage[] | null;
}

export interface TicketChangeStatusResponse {
	ticketID: number;
	newStatus: TicketStatus;
}

export interface ValidationMessage {
	field?: string | null;
	message: string;
}

export interface TicketChangeStatusRequest {
	ticketID: number;
	status: TicketStatus;
	changeReason?: string | null;
	groupCode?: string | null;
}

export interface AccessRolesListDto {
	count: number;
	accessRoles: AccessRoleListItemDto[];
}

export interface AccessRoleListItemDto {
	accessRoleID: number;
	name: string;
	accessRoleCode: string;
}

export interface GetAccessRoleListQuery {
	offset: number;
	limit: number;
	filter: FilterPropsAccessRole;
	orderBy: string;
	desc: boolean;
}

export interface FilterPropsAccessRole {
	name: string;
	accessRoleCode: string;
}

export interface AccessRoleDetailDto {
	accessRoleID: number;
	name: string;
	accessRights: AccessRoleAccessRightDto[];
}

export interface AccessRoleAccessRightDto {
	accessRightCode: string;
	note?: string | null;
	isSelected: boolean;
}

export interface AccessRightsUpdateRequest {
	accessRoleID: number;
	accessRightsCodes: string[];
}

export interface InvoiceItemCategoriesListDto {
	count: number;
	invoiceItemCategories: InvoiceItemCategoryDto[];
}

export interface InvoiceItemCategoryDto {
	invoiceItemCategoryCode: number;
	name: string;
	divisionID: number;
	divisionName: string;
	isCode: string;
	isActive: boolean;
}

export interface GetInvoiceItemCategoriesListQuery {
	offset: number;
	limit: number;
	filterName?: string | null;
	filterIsCode?: string | null;
	filterDivisionName?: string | null;
	orderBy: string;
	desc: boolean;
}

export interface ResultOfInvoiceItemCategoryDto {
	data?: any | null;
	isValid: boolean;
	validationErrors?: ValidationMessage[] | null;
}

export interface SaveInvoiceItemCategoryRequest {
	invoiceItemCategoryCode?: number | null;
	name: string;
	isCode: string;
	divisionID: number;
	isNew: boolean;
}

export interface DivisionDto {
	divisionID: number;
	name: string;
}

export interface ListQueryResultOfEmployeeListDto {
	items: EmployeeListDto[];
	totalCount: number;
}

export interface EmployeeListDto {
	employeeID: number;
	userID?: number | null;
	firstName: string;
	lastName: string;
	dateUpdated?: string | null;
	updatedByUserFirstName?: string | null;
	updatedByUserLastName?: string | null;
	positionName: string;
	profilePhotoUrl?: string | null;
	contactPersonFirstName?: string | null;
	contactPersonLastName?: string | null;
	dateCreated: string;
	name: string;
	departments: EmployeeDepartmentListDto[];
	isActive: boolean;
}

export interface EmployeeDepartmentListDto {
	departmentName: string;
}

export interface GetEmployeeListQuery {
	limit: number;
	offset: number;
	filter: FilterPropsEmployee;
	orderBy: string;
	desc: boolean;
}

export interface FilterPropsEmployee {
	name: string;
	updatedByUserName: string;
	positionName?: string | null;
	contactPersonName?: string | null;
	isActive?: boolean | null;
	departmentNames: string;
	onlyActive?: boolean | null;
}

export interface EmployeeDto {
	employeeID: number;
	firstName: string;
	lastName: string;
	dateUpdated?: string | null;
	email: string;
	phone: string;
	supervisorFirstName?: string | null;
	supervisorLastName?: string | null;
	supervisorProfilePhotoUrl?: string | null;
	supervisorID?: number | null;
	positionName?: string | null;
	anniversaryDate?: string | null;
	birthDate?: string | null;
	profilePhotoUrl?: string | null;
	isHelpdeskWritingDisabled: boolean;
	isActive: boolean;
	showReminder: boolean;
	canShowTicketsForColleaguesFromOwnDepartments: boolean;
	positions: EmployeePositionDto[];
	departments: EmployeeDepartmentDto[];
	departmentChanges: EmployeeDepartmentChangeDto[];
	documents: DocumentDto[];
	companyID?: number | null;
	companyName?: string | null;
	employeeTypeName?: string | null;
	employeeTypeID: EmployeeTypeID;
	employeeTypeCategoryID: EmployeeTypeCategoryID;
}

export interface EmployeePositionDto {
	employeePositionID: number;
	positionName: string;
	positionID: number;
	dateFrom: string;
	dateTo?: string | null;
}

export interface EmployeeDepartmentDto {
	employeeDepartmentID: number;
	departmentID: number;
	dateFrom: string;
	departmentName: string;
}

export interface EmployeeDepartmentChangeDto {
	employeeDepartmentChangeID: number;
	departmentID: number;
	dateChanged: string;
	actionType: ActionType;
	departmentName: string;
}

export enum ActionType {
	Added = "Added",
	Deleted = "Deleted"
}

export interface DocumentDto {
	documentID: number;
	name: string;
	url: string;
}

export enum EmployeeTypeID {
	Employee = "Employee",
	DPP = "DPP",
	Internship = "Internship",
	Kontraktor = "Kontraktor",
	Freelancer = "Freelancer",
	Bodyshop = "Bodyshop",
	Supplier = "Supplier",
	BodyshopInternal = "BodyshopInternal"
}

export enum EmployeeTypeCategoryID {
	Internal = "Internal",
	External = "External"
}

export interface ResultOfEmployeeSaveResponse {
	data?: any | null;
	isValid: boolean;
	validationErrors?: ValidationMessage[] | null;
}

export interface EmployeeSaveResponse {
	employee: EmployeeDto;
}

export interface EmployeeSaveRequest {
	employee: EmployeeDto;
}

export interface ResultOfBoolean {
	data: boolean;
	isValid: boolean;
	validationErrors?: ValidationMessage[] | null;
}

export interface ListItemDto {
	itemID: number;
	name: string;
}

export interface GetPositionsAutocompleteQuery {
	search?: string | null;
	positionType: PositionType;
}

export enum PositionType {
	Internal = "Internal",
	External = "External"
}

export interface EmployeeAutocompleteDto {
	employeeID: number;
	name: string;
	firstName: string;
	lastName: string;
	email: string;
	phone?: string | null;
	position: EmployeeAutocompletePositionDto;
}

export interface EmployeeAutocompletePositionDto {
	positionID: number;
	positionName: string;
}

export interface GetEmployeesAutocompleteQuery {
	search?: string | null;
	employeeTypeCategoryIDs: EmployeeTypeCategoryID[];
}

export interface EmployeeTypeListDto {
	employeeTypeID: EmployeeTypeID;
	name: string;
	employeeTypeCategoryID: EmployeeTypeCategoryID;
}

export interface CompaniesListDto {
	count: number;
	companies: CompanyDto[];
}

export interface CompanyDto {
	companyID: number;
	name: string;
	identificationNumber: string;
	taxIdentificationNumber?: string | null;
	street: string;
	streetNo: string;
	postalCode: string;
	city: string;
	isSupplier: boolean;
	isCustomer: boolean;
	isMarketplaceEnabled: boolean;
	cooperationDueDate?: string | null;
	isActive: boolean;
	signaturePhotoUrl?: string | null;
	logoPhotoUrl?: string | null;
	image?: any | null;
	logo?: any | null;
	dateUpdated?: string | null;
	documents: DocumentDto[];
	contacts: CompanyContactPersonDto[];
}

export interface DataImage {
	name: string;
	contentType: string;
	size?: number | null;
	base64: string;
}

export interface CompanyContactPersonDto {
	companyContactPersonID: number;
	companyID: number;
	sourceEmployeeID?: number | null;
	sourceEmployeeName?: string | null;
	email?: string | null;
	firstName: string;
	lastName: string;
	phone?: string | null;
	positionID: number;
	charges: CompanyContactPersonChargeDto[];
	positionName: string;
}

export interface CompanyContactPersonChargeDto {
	dateCreated: string;
	createdBy: number;
	createdByFirstName: string;
	createdByLastName: string;
	dateUpdated?: string | null;
	updatedBy?: number | null;
	companyContactPersonChargeID: number;
	manDayCharge: number;
	dateFrom: string;
	dateTo?: string | null;
	companyContactPersonID: number;
	currencyID: CurrencyIDs;
}

export enum CurrencyIDs {
	CZK = "CZK",
	EUR = "EUR"
}

export interface GetCompaniesListQuery {
	offset: number;
	limit: number;
	filter: FilterPropsCompanies;
	orderBy: string;
	desc: boolean;
}

export interface FilterPropsCompanies {
	name: string;
	street: string;
	postalCode: string;
	city: string;
	isActive?: boolean | null;
	role: RoleFilterType;
}

export enum RoleFilterType {
	None = "None",
	Customer = "Customer",
	Supplier = "Supplier",
	Marketplace = "Marketplace"
}

export interface ResultOfCompanySaveResponse {
	data?: any | null;
	isValid: boolean;
	validationErrors?: ValidationMessage[] | null;
}

export interface CompanySaveResponse {
	company: CompanyDto;
}

export interface CompanySaveRequest {
	company: CompanyDto;
}

export interface ResultOfCompanyContactPersonDto {
	data?: any | null;
	isValid: boolean;
	validationErrors?: ValidationMessage[] | null;
}

export interface ResultOfInteger {
	data: number;
	isValid: boolean;
	validationErrors?: ValidationMessage[] | null;
}

export interface UsersListDto {
	count: number;
	users: UserDto[];
}

export interface UserDto {
	userID: number;
	login: string;
	firstName: string;
	lastName: string;
	profilePhotoUrl?: string | null;
	lastLoginDate?: string | null;
	isActive: boolean;
	employeeID: number;
	accessRoles: UserAccessRoleDto[];
}

export interface UserAccessRoleDto {
	name: string;
	accessRoleID: number;
	hasRole: boolean;
	accessRights: UserAccessRoleRightDto[];
}

export interface UserAccessRoleRightDto {
	code: string;
}

export interface GetUserListQuery {
	offset: number;
	limit: number;
	filter: FilterPropsUsers;
	orderBy: string;
	desc: boolean;
}

export interface FilterPropsUsers {
	firstAndLastName: string;
	login: string;
	isActive?: boolean | null;
}

export interface UserUpdateDto {
	userID: number;
	accessRolesIDs: number[];
	isActive: boolean;
	employeeID: number;
}

export interface SignInResult {
	isSuccessful: boolean;
	token?: string | null;
	login: string;
	firstName: string;
	lastName: string;
	profileImageUrl: string;
	identityProviderType: IdentityProviderType;
	error: AuthError;
	errorMessage: string;
	accessRightCodes: string[];
}

export enum IdentityProviderType {
	None = "None",
	Google = "Google"
}

export enum AuthError {
	GoogleAuth = "GoogleAuth",
	ApplicationVerification = "ApplicationVerification",
	UserNotFound = "UserNotFound"
}

export interface SignInModel {
	authCode: string;
	identityProvider: IdentityProviderType;
}

export interface UserSecurityDto {
	userID: number;
	login: string;
	password: string;
	accessRightCodes: string[];
}

export interface WebLogRequestBatch {
	dateCreated: string;
	webLogRequests: WebLogRequest[];
}

export interface WebLogRequest {
	dateCreated: string;
	error: string;
	additionalInfo: string;
	reduxState: string;
}

export interface GuidepostDto {
	categories: ApplicationCategoryDto[];
	recentApplications: ApplicationDto[];
}

export interface ApplicationCategoryDto {
	category: CategoryDto;
	applications: ApplicationDto[];
}

export interface CategoryDto {
	name: string;
}

export interface ApplicationDto {
	applicationCode: ApplicationCodes;
	name: string;
	imageUri?: string | null;
	url: string;
}

export enum ApplicationCodes {
	Dashboard = "Dashboard",
	HumanResourcesEmployees = "HumanResourcesEmployees",
	ManagementUsers = "ManagementUsers",
	ManagementCompanies = "ManagementCompanies",
	ManagementAccessRoles = "ManagementAccessRoles",
	OperationalDutyFree = "OperationalDutyFree",
	FakturoidApp = "FakturoidApp",
	BlogicGame = "BlogicGame",
	GoogleRoot = "GoogleRoot",
	CommitGuru = "CommitGuru",
	Marketplace = "Marketplace",
	Dovolena = "Dovolena",
	Projekty = "Projekty",
	BeTested = "BeTested",
	Confluence = "Confluence",
	Jira = "Jira",
	HelpdeskIT = "HelpdeskIT",
	BlogicAIChat = "BlogicAIChat",
	LunchBuddy = "LunchBuddy",
	RovoChat = "RovoChat"
}

export interface ApplicationLogVisitRequest {
	applicationCode: ApplicationCodes;
	dateCreated: string;
}

export interface ResultOfDocumentationDto {
	data?: any | null;
	isValid: boolean;
	validationErrors?: ValidationMessage[] | null;
}

export interface DocumentationDto {
	title: string;
	documentationUrl: string;
	displayOnPageUrl: string;
}

export interface ResultBase {
	isValid: boolean;
	validationErrors?: ValidationMessage[] | null;
}

export interface RunDailyJobRequest {
	jobName: string;
	password: string;
}

const API_URL = process.env.REACT_APP_API_URL;

export const postTicketGetList = (requestContract: GetTicketsRequest, headers = new Headers()): 
	Promise<FetchResponse<GetTicketsResponse>> => 
	apiPost(`${API_URL}/api/Ticket/get-list`, requestContract, headers);

export const postTicketGetSubordinatesTickets = (headers = new Headers()): 
	Promise<FetchResponse<SubordinatesTicketListDto[]>> => 
	apiPost(`${API_URL}/api/Ticket/get-subordinates-tickets`, {}, headers);

export const postTicketChangeStatus = (requestContract: TicketChangeStatusRequest, headers = new Headers()): 
	Promise<FetchResponse<ResultOfTicketChangeStatusResponse>> => 
	apiPost(`${API_URL}/api/Ticket/change-status`, requestContract, headers);

export const postAccessRolesGetList = (requestContract: GetAccessRoleListQuery, headers = new Headers()): 
	Promise<FetchResponse<AccessRolesListDto>> => 
	apiPost(`${API_URL}/api/AccessRoles/get-list`, requestContract, headers);

export const getAccessRolesGetDetail = (accessRoleID: number, headers = new Headers()): 
	Promise<FetchResponse<AccessRoleDetailDto>> => {
	const queryParams = {
		accessRoleID
	}
	return apiGet(`${API_URL}/api/AccessRoles/get-detail`, headers, queryParams);
}

export const putAccessRolesUpdateAccessRights = (requestContract: AccessRightsUpdateRequest, headers = new Headers()): 
	Promise<FetchResponse<any>> => 
	apiPut(`${API_URL}/api/AccessRoles/update-access-rights`, requestContract, headers);

export const postInvoiceItemCategoriesGetList = (requestContract: GetInvoiceItemCategoriesListQuery, headers = new Headers()): 
	Promise<FetchResponse<InvoiceItemCategoriesListDto>> => 
	apiPost(`${API_URL}/api/InvoiceItemCategories/get-list`, requestContract, headers);

export const getInvoiceItemCategoriesGetDetail = (code: number, headers = new Headers()): 
	Promise<FetchResponse<InvoiceItemCategoryDto>> => {
	const queryParams = {
		code
	}
	return apiGet(`${API_URL}/api/InvoiceItemCategories/get-detail`, headers, queryParams);
}

export const postInvoiceItemCategoriesSave = (requestContract: SaveInvoiceItemCategoryRequest, headers = new Headers()): 
	Promise<FetchResponse<ResultOfInvoiceItemCategoryDto>> => 
	apiPost(`${API_URL}/api/InvoiceItemCategories/save`, requestContract, headers);

export const getInvoiceItemCategoriesGetDivisions = (headers = new Headers()): 
	Promise<FetchResponse<DivisionDto[]>> => {
	return apiGet(`${API_URL}/api/InvoiceItemCategories/get-divisions`, headers, {});
}

export const postHumanResourceGetEmployeeList = (requestContract: GetEmployeeListQuery, headers = new Headers()): 
	Promise<FetchResponse<ListQueryResultOfEmployeeListDto>> => 
	apiPost(`${API_URL}/api/HumanResource/get-employee-list`, requestContract, headers);

export const getHumanResourceGetEmployee = (employeeID: number, headers = new Headers()): 
	Promise<FetchResponse<EmployeeDto>> => {
	const queryParams = {
		employeeID
	}
	return apiGet(`${API_URL}/api/HumanResource/get-employee`, headers, queryParams);
}

export const postHumanResourceSaveEmployee = (requestContract: EmployeeSaveRequest, headers = new Headers()): 
	Promise<FetchResponse<ResultOfEmployeeSaveResponse>> => 
	apiPost(`${API_URL}/api/HumanResource/save-employee`, requestContract, headers);

export const deleteHumanResourceDeleteEmployee = (employeeID: number, headers = new Headers()): 
	Promise<FetchResponse<ResultOfBoolean>> => {
	const queryParams = {
		employeeID
	}
	return apiDelete(`${API_URL}/api/HumanResource/delete-employee`, headers, queryParams);
}

export const getHumanResourceDepartmentsAutocomplete = (search: string | undefined | null, headers = new Headers()): 
	Promise<FetchResponse<ListItemDto[]>> => {
	const queryParams = {
		search
	}
	return apiGet(`${API_URL}/api/HumanResource/departments-autocomplete`, headers, queryParams);
}

export const postHumanResourcePositionsAutocomplete = (requestContract: GetPositionsAutocompleteQuery, headers = new Headers()): 
	Promise<FetchResponse<ListItemDto[]>> => 
	apiPost(`${API_URL}/api/HumanResource/positions-autocomplete`, requestContract, headers);

export const postHumanResourceEmployeesAutocomplete = (requestContract: GetEmployeesAutocompleteQuery, headers = new Headers()): 
	Promise<FetchResponse<EmployeeAutocompleteDto[]>> => 
	apiPost(`${API_URL}/api/HumanResource/employees-autocomplete`, requestContract, headers);

export const getHumanResourceCompanyAutocomplete = (search: string | undefined | null, headers = new Headers()): 
	Promise<FetchResponse<ListItemDto[]>> => {
	const queryParams = {
		search
	}
	return apiGet(`${API_URL}/api/HumanResource/company-autocomplete`, headers, queryParams);
}

export const getHumanResourceGetEmployeeTypeList = (headers = new Headers()): 
	Promise<FetchResponse<EmployeeTypeListDto[]>> => {
	return apiGet(`${API_URL}/api/HumanResource/get-employee-type-list`, headers, {});
}

export const postCompaniesGetList = (requestContract: GetCompaniesListQuery, headers = new Headers()): 
	Promise<FetchResponse<CompaniesListDto>> => 
	apiPost(`${API_URL}/api/Companies/get-list`, requestContract, headers);

export const getCompaniesGetCompany = (id: number, headers = new Headers()): 
	Promise<FetchResponse<CompanyDto>> => {
	const queryParams = {
		id
	}
	return apiGet(`${API_URL}/api/Companies/get-company`, headers, queryParams);
}

export const postCompaniesSaveCompany = (requestContract: CompanySaveRequest, headers = new Headers()): 
	Promise<FetchResponse<ResultOfCompanySaveResponse>> => 
	apiPost(`${API_URL}/api/Companies/save-company`, requestContract, headers);

export const deleteCompaniesDeleteCompany = (id: number, headers = new Headers()): 
	Promise<FetchResponse<ResultOfBoolean>> => {
	const queryParams = {
		id
	}
	return apiDelete(`${API_URL}/api/Companies/delete-company`, headers, queryParams);
}

export const getCompaniesGetAllIdentificationNumbers = (headers = new Headers()): 
	Promise<FetchResponse<[]>> => {
	return apiGet(`${API_URL}/api/Companies/get-all-identification-numbers`, headers, {});
}

export const postCompaniesSaveCompanyContactPerson = (requestContract: CompanyContactPersonDto, headers = new Headers()): 
	Promise<FetchResponse<ResultOfCompanyContactPersonDto>> => 
	apiPost(`${API_URL}/api/Companies/save-company-contact-person`, requestContract, headers);

export const deleteCompaniesDeleteCompanyContactPerson = (id: number, headers = new Headers()): 
	Promise<FetchResponse<ResultOfInteger>> => {
	const queryParams = {
		id
	}
	return apiDelete(`${API_URL}/api/Companies/delete-company-contact-person`, headers, queryParams);
}

export const postUsersGetList = (requestContract: GetUserListQuery, headers = new Headers()): 
	Promise<FetchResponse<UsersListDto>> => 
	apiPost(`${API_URL}/api/Users/get-list`, requestContract, headers);

export const getUsersGetUser = (id: number, headers = new Headers()): 
	Promise<FetchResponse<UserDto>> => {
	const queryParams = {
		id
	}
	return apiGet(`${API_URL}/api/Users/get-user`, headers, queryParams);
}

export const getUsersGetLoggedUserInfo = (headers = new Headers()): 
	Promise<FetchResponse<EmployeeDto>> => {
	return apiGet(`${API_URL}/api/Users/get-logged-user-info`, headers, {});
}

export const deleteUsersDeleteUser = (id: number, headers = new Headers()): 
	Promise<FetchResponse<any>> => {
	const queryParams = {
		id
	}
	return apiDelete(`${API_URL}/api/Users/delete-user`, headers, queryParams);
}

export const postUsersUpdate = (requestContract: UserUpdateDto, headers = new Headers()): 
	Promise<FetchResponse<ResultOfBoolean>> => 
	apiPost(`${API_URL}/api/Users/update`, requestContract, headers);

export const postAuthSignIn = (requestContract: SignInModel, headers = new Headers()): 
	Promise<FetchResponse<SignInResult>> => 
	apiPost(`${API_URL}/api/Auth/sign-in`, requestContract, headers);

export const getAuthCurrentUserAccessRights = (headers = new Headers()): 
	Promise<FetchResponse<UserSecurityDto>> => {
	return apiGet(`${API_URL}/api/Auth/current-user-access-rights`, headers, {});
}

export const postCacheClear = (headers = new Headers()): 
	Promise<FetchResponse<any>> => 
	apiPost(`${API_URL}/api/Cache/Clear`, {}, headers);

export const postLogError = (requestContract: WebLogRequestBatch, headers = new Headers()): 
	Promise<FetchResponse<any>> => 
	apiPost(`${API_URL}/api/Log/Error`, requestContract, headers);

export const postApplicationsGetGuidepost = (headers = new Headers()): 
	Promise<FetchResponse<GuidepostDto>> => 
	apiPost(`${API_URL}/api/Applications/get-guidepost`, {}, headers);

export const postApplicationsLogApplicationVisit = (requestContract: ApplicationLogVisitRequest, headers = new Headers()): 
	Promise<FetchResponse<ResultOfBoolean>> => 
	apiPost(`${API_URL}/api/Applications/log-application-visit`, requestContract, headers);

export const getApplicationsGetCurrentDocs = (currentUrl: string, headers = new Headers()): 
	Promise<FetchResponse<ResultOfDocumentationDto>> => {
	const queryParams = {
		currentUrl
	}
	return apiGet(`${API_URL}/api/Applications/get-current-docs`, headers, queryParams);
}

export const postApplicationsRunDailyJob = (requestContract: RunDailyJobRequest, headers = new Headers()): 
	Promise<FetchResponse<ResultBase>> => 
	apiPost(`${API_URL}/api/Applications/run-daily-job`, requestContract, headers);

export const getGuidepostPlugin = (headers = new Headers()): 
	Promise<FetchResponse<any>> => {
	return apiGet(`${API_URL}/api/Guidepost/plugin`, headers, {});
}

export const API = { 
	postTicketGetList,
	postTicketGetSubordinatesTickets,
	postTicketChangeStatus,
	postAccessRolesGetList,
	getAccessRolesGetDetail,
	putAccessRolesUpdateAccessRights,
	postInvoiceItemCategoriesGetList,
	getInvoiceItemCategoriesGetDetail,
	postInvoiceItemCategoriesSave,
	getInvoiceItemCategoriesGetDivisions,
	postHumanResourceGetEmployeeList,
	getHumanResourceGetEmployee,
	postHumanResourceSaveEmployee,
	deleteHumanResourceDeleteEmployee,
	getHumanResourceDepartmentsAutocomplete,
	postHumanResourcePositionsAutocomplete,
	postHumanResourceEmployeesAutocomplete,
	getHumanResourceCompanyAutocomplete,
	getHumanResourceGetEmployeeTypeList,
	postCompaniesGetList,
	getCompaniesGetCompany,
	postCompaniesSaveCompany,
	deleteCompaniesDeleteCompany,
	getCompaniesGetAllIdentificationNumbers,
	postCompaniesSaveCompanyContactPerson,
	deleteCompaniesDeleteCompanyContactPerson,
	postUsersGetList,
	getUsersGetUser,
	getUsersGetLoggedUserInfo,
	deleteUsersDeleteUser,
	postUsersUpdate,
	postAuthSignIn,
	getAuthCurrentUserAccessRights,
	postCacheClear,
	postLogError,
	postApplicationsGetGuidepost,
	postApplicationsLogApplicationVisit,
	getApplicationsGetCurrentDocs,
	postApplicationsRunDailyJob,
	getGuidepostPlugin
}

